define('order_wizard_cartitems_module_pickup_in_store.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('order_wizard_cartitems_module_pickup_in_store', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-view=\"Packages.Collection\"></div>  ";
},"useData":true}, 'extensions/ES/MaxaMasterTheme/24.1.1/', 'extensions/ES/MaxaMasterTheme/24.1.1/', Handlebars);
});